var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSintEustatius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.98242 29.2282C9.5503 30.9835 12.6551 32.0109 16.0004 32.0109C19.3456 32.0109 22.4505 30.9835 25.0183 29.2282L16.0004 27.8369L6.98242 29.2282Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0183 2.79337C22.4505 1.03805 19.3456 0.0107422 16.0004 0.0107422C12.6551 0.0107422 9.55017 1.03805 6.98242 2.79337L16.0004 4.18468L25.0183 2.79337Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98242 29.2282C9.5503 30.9835 12.6551 32.0109 16.0004 32.0109C19.3456 32.0109 22.4505 30.9835 25.0183 29.2282L16.0004 27.8369L6.98242 29.2282Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0183 2.79337C22.4505 1.03805 19.3456 0.0107422 16.0004 0.0107422C12.6551 0.0107422 9.55017 1.03805 6.98242 2.79337L16.0004 4.18468L25.0183 2.79337Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9588 14.9674C31.5798 10.0293 28.5793 5.22827 25.0175 2.79346H6.98164C3.03564 5.49102 0.358953 9.90902 0.0332031 14.9674L15.9996 16.0109L31.9588 14.9674Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0332031 17.0545C0.358953 22.1129 3.03558 26.5309 6.98158 29.2284H25.0175C28.9636 26.5309 31.6401 22.1129 31.9659 17.0545L15.9996 16.011L0.0332031 17.0545Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9592 14.9672H17.0435V2.09766H14.9566V14.9672H0.0336875C0.0115 15.3122 0 15.6601 0 16.0107C0 16.3613 0.0114375 16.7092 0.033625 17.0542H14.9566V29.9238H17.0435V17.0542H31.9664C31.9886 16.7092 32 16.3613 32 16.0107C32 15.6627 31.9859 15.3146 31.9592 14.9672Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26086 16.0108L15.9999 9.8894L25.7391 16.0108L15.9999 22.1322L6.26086 16.0108Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 18.7933H22.9565L20.1739 14.6194L18.7826 16.0107L17.3913 15.3151L16 17.402H13.2174L11.8261 16.0107L10.4348 18.7933Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.8369L16.3454 12.8997H17.4628L16.5587 13.5567L16.9041 14.6195L16 13.9627L15.0959 14.6195L15.4412 13.5567L14.5372 12.8997H15.6546L16 11.8369Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 8.14038L3.47852 16.0108L16.0002 23.8811L28.522 16.0108L16.0002 8.14038ZM7.40027 16.0108L16.0002 10.6053L24.6003 16.0108L16.0002 21.4162L7.40027 16.0108Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSintEustatius);
export default __webpack_public_path__ + "static/media/flag_sint_eustatius.dde843f46937a977b0a02f7cb1ee9611.svg";
export { ForwardRef as ReactComponent };